import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import { EuiSpacer } from '@elastic/eui';
import SuccessBox from 'components/Web_User_Interface/1440p_Series/System/WebUI/SuccessBox';
import PermissionBox from 'components/Web_User_Interface/1440p_Series/_permissions/SystemPerm';
import VideoWebUIWidgets from 'components/Web_User_Interface/1440p_Series/System/WebUI/VideoWebUIWidgets';
import TilesTable from 'components/Web_User_Interface/1440p_Series/System/WebUI/tilesTable';
import BreadCrumbs from 'components/Layout/BreadCrumbs';
import SEOHelmet from 'components/Layout/SEOHelmet';
export const _frontmatter = {
  "title": "System Menü // WebUI",
  "path": "/Web_User_Interface/1440p_Serie/System/WebUI/",
  "dateChanged": "2021-12-12",
  "author": "Mike Polinowski",
  "excerpt": "Einstellungen für die Weboberfläche Ihrer INSTAR 1080p FullHD IP Kamera",
  "image": "./WebUI_1440p_SearchThumb_System_WebUI.png",
  "social": "/images/Search/WebUI_1440p_SearchThumb_System_WebUI.webp",
  "toc": "/images/Search/TOC_Icons/Wiki_Tiles_WebUI_white.webp",
  "chapter": "1440p Web User Interface"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">




    <SEOHelmet title='System Menü // WebUI' dateChanged='2021-12-12' author='Mike Polinowski' tag='INSTAR IP Camera' description='Einstellungen für die Weboberfläche Ihrer INSTAR 1080p FullHD IP Kamera' image='/images/Search/WebUI_1440p_SearchThumb_System_WebUI.png' twitter='/images/Search/WebUI_1440p_SearchThumb_System_WebUI.webp' location={props.location.pathname} mdxType="SEOHelmet" />
    <BreadCrumbs locationBC={props.location} locationDE={props.location.pathname} locationEN='/en/Web_User_Interface/1440p_Series/System/WebUI/' locationFR='/fr/Web_User_Interface/1440p_Series/System/WebUI/' crumbLabel="WebUI" mdxType="BreadCrumbs" />
    <h1 {...{
      "id": "ultrahd-serien-2k-1440p--4k-2160p",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h1" {...{
        "href": "#ultrahd-serien-2k-1440p--4k-2160p",
        "aria-label": "ultrahd serien 2k 1440p  4k 2160p permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`UltraHD Serien (2K+ 1440p & 4K 2160p)`}</h1>
    <h2 {...{
      "id": "system-menü",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#system-men%C3%BC",
        "aria-label": "system menü permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`System Menü`}</h2>
    <EuiSpacer mdxType="EuiSpacer" />
    <SuccessBox mdxType="SuccessBox" />
    <EuiSpacer mdxType="EuiSpacer" />
    <PermissionBox mdxType="PermissionBox" />
    <EuiSpacer mdxType="EuiSpacer" />
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "920px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/de/static/a85d61466e426896dd52be7e9324bb39/fbf08/1440p_Settings_System_WebUI.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "79.13043478260869%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAQCAYAAAAWGF8bAAAACXBIWXMAAA7rAAAO6wFxzYGVAAADqUlEQVQ4y32T+0+VdRzH+TfaCtiqc4lFMtY55zlwuCkcrofzPOd+AzzncEgJ2Ozi5KJEbWjosDBAXESKJHEpBwdECsxxUTBbrvytZoSYpihlzJrbq87Drdbqh9c+++zZXnt/9n0/UXFqJXqjncLXPmBHeRtZFe0yGbveI6Xs2H9iCLWQU9WBvbaH7KoOFIkZRD/5BFEq5bOkFxYROBTGcaAPV30/rjcGcNYPYN3fj01m4G+s73V9eOp7cdX14D84RFKOG8UzTxOlUqnRal7EbjHjsBTK2DeQTIgFOetkb5FvRDSbEW0umUJRInN7JoLOQJRarUYQBNxuDy6nC6fTid1ux2q1IlksSJIkI8rTgmSxIZnykCqasB39GtvRa0jVp8lMT0erTd4Surw+HB4fbq8Pt68Yl8eHaLUhWW2IVjuSxYokbohFzN4yLGU12MpqsJZUkLk9a0uo02oItIfZ/cm3+E/PU973FTt7rhA8c5WS7jlCg9fxHvwQsdCEOT8Xb0M7gf5vONR7ntkvxmltPUZaagZ6YV2o0WhkSfX8I0Ljd9g7vUJw/GfKL9wneP42VZf+oLhtZE2Yl01R88dUXn5M59yP/HJnicGBATLSUjAkJUceRYWg1eA/dYngZ8sEwgsEz90iOLJI6dgtAsMLhCZXKGo5uyn0NvUQmFihMvwdDVO3qTp+lqz0FIRIQoVSiaDTUvrRPC9f/JWysSVqpu5ROvYTddPLBEeX2DO7SknrEOYN4ZEzVE6v4g8vErq4iqftHMb0VAR9ClFKpZIkQcB/cobg+F0Cwz8QHL1JMJJ09CaB4RuUTtzH9+6nmwl9h3t46cIKweEblE0+YGfbCJqEeBRK9ZpQq9Wwq/8ar155TOnny1RMPSQ0+YDqy7/J++tXwd8xhtlUgJiXjetwLxUzjygJL/LKzEP5W7xawVPRMRsn6/DUHMHb2Im74Tiet07gfrMDb2RG9sYuHHvqkUSRgtwc9r3TSdfcAnXh6xSP3qW4ZYhtcSpiYmOJUigU6PV6JFM+hblG+aR/kWtELMiTy240GjnZ1cnv95Y4Nfs9lV+C/8QELzynJDoijJwcKbbFakWULP/DWqHz8gvYV3uAU93d1DW/j795EN/eJrY9H0d0TMxWQofDgc1m2yTy+/0TBzaLGefu/ThruzFVNNOYY6J7RxZv5xUQn5hITHT0Wg8TEhIwGAyyeAOtVisXfov1XadHSE5DSE7FoBNI1QnyVKpUxP6V8E/mwc3aqcJ1fwAAAABJRU5ErkJggg==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/a85d61466e426896dd52be7e9324bb39/e4706/1440p_Settings_System_WebUI.avif 230w", "/de/static/a85d61466e426896dd52be7e9324bb39/d1af7/1440p_Settings_System_WebUI.avif 460w", "/de/static/a85d61466e426896dd52be7e9324bb39/7f308/1440p_Settings_System_WebUI.avif 920w", "/de/static/a85d61466e426896dd52be7e9324bb39/4346e/1440p_Settings_System_WebUI.avif 962w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/avif"
            }}></source><source parentName="picture" {...{
              "srcSet": ["/de/static/a85d61466e426896dd52be7e9324bb39/a0b58/1440p_Settings_System_WebUI.webp 230w", "/de/static/a85d61466e426896dd52be7e9324bb39/bc10c/1440p_Settings_System_WebUI.webp 460w", "/de/static/a85d61466e426896dd52be7e9324bb39/966d8/1440p_Settings_System_WebUI.webp 920w", "/de/static/a85d61466e426896dd52be7e9324bb39/c76c7/1440p_Settings_System_WebUI.webp 962w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/a85d61466e426896dd52be7e9324bb39/81c8e/1440p_Settings_System_WebUI.png 230w", "/de/static/a85d61466e426896dd52be7e9324bb39/08a84/1440p_Settings_System_WebUI.png 460w", "/de/static/a85d61466e426896dd52be7e9324bb39/c0255/1440p_Settings_System_WebUI.png 920w", "/de/static/a85d61466e426896dd52be7e9324bb39/fbf08/1440p_Settings_System_WebUI.png 962w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/de/static/a85d61466e426896dd52be7e9324bb39/c0255/1440p_Settings_System_WebUI.png",
              "alt": "Web User Interface - 1440p Series - System WebUI",
              "title": "Web User Interface - 1440p Series - System WebUI",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    {
      /*
      import WebUITable from 'components/Web_User_Interface/1440p_Series/System/WebUI/webUITable'
      <EuiSpacer />
      <WebUITable />
      <EuiSpacer />
      */
    }
    <h3 {...{
      "id": "personalisieren-sie-die-schnellzugriffsleiste",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#personalisieren-sie-die-schnellzugriffsleiste",
        "aria-label": "personalisieren sie die schnellzugriffsleiste permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Personalisieren Sie die Schnellzugriffsleiste`}</h3>
    <p>{`Die Schnellzugriffsleiste erlaubt Ihnen häufig verwendete Funktionen auf der rechten Seite der Hauptseite schnell und mit einem Klick zugänglich zu machen. Die  Anordnung sowie die Auswahl können Sie in diesem Menü individuell Ihren Bedürfnissen anpassen.`}</p>
    <EuiSpacer mdxType="EuiSpacer" />
    <VideoWebUIWidgets mdxType="VideoWebUIWidgets" />
    <EuiSpacer mdxType="EuiSpacer" />
    <h4 {...{
      "id": "drag--drop",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h4" {...{
        "href": "#drag--drop",
        "aria-label": "drag  drop permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Drag & Drop`}</h4>
    <p>{`Um die Positionen bzw. die einzellnen Buttons in der Schnellzugriffsleiste anzupassen, müssen Sie lediglich den gewünschten Button auf die gewünscht Position ziehen.`}</p>
    <p><strong parentName="p">{`Achtung!`}</strong>{` Beim Internet Explorer sowie dem Edge Browser müssen Sie zunächst einen Button mit einem Klick markieren. Dieser wird dann orange unterlegt. Wählen Sie anschliessend die Position aus in dem Sie den markierten Button haben möchten. Gültige Möglichkeiten werden Ihne orange dargestellt, wenn Sie mit der Maus drüber fahren.`}</p>
    <h3 {...{
      "id": "schnellzugriff-kacheln",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#schnellzugriff-kacheln",
        "aria-label": "schnellzugriff kacheln permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Schnellzugriff Kacheln`}</h3>
    <EuiSpacer mdxType="EuiSpacer" />
    <TilesTable mdxType="TilesTable" />
    <EuiSpacer mdxType="EuiSpacer" />
    <h3 {...{
      "id": "digitaler-zoom",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#digitaler-zoom",
        "aria-label": "digitaler zoom permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Digitaler Zoom`}</h3>
    <p>{`Aktivieren Sie die digitale Zoomsteuerung unten rechts, um die Mitte des Live-Videos Ihrer Kamera um das `}<strong parentName="p">{`6-fache`}</strong>{` zu vergrößern:`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "920px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/de/static/4b290e93b9a61a5f6207b5cabf0352fb/e2310/1440p_Settings_System_WebUI_digital_Zoom.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "63.04347826086957%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAANCAYAAACpUE5eAAAACXBIWXMAAA7rAAAO6wFxzYGVAAADNklEQVQ4yx2SaU8bBxiEX+OUJlWDOOyEy/jEx+7ie9cXPtfrA19gik0dYjcEIWjUJoU2SqtKqfiQJh+qSuk/6A/oX3wq/GE0mnmlGWn0SrfbodVs0m615txpt2m3mjSsOo16HdM0Mc3aHFa9PvebDYtSscjt7Q3/fP6MoeuUSkUaloV4QwresIonrOGOaOxE9uZwRaK4lTh6No+RK8zZp8Vxhe/vUVzBCIlMlmy5xpYvwKbHT1DREFlyICvryMoGsrqFrO4gDg/i9CFPAiy6IqztRlkO7M313Hd4EecOiytryGMnttUNFpadrGy6EHG4sD31Iut+bJtBbNsqNncMmzeJ3Z9GXCmyBYNE1kB2kth9CcQd50uPitPj4cFWENtGALvTxZrLi8gTH7IZRLYjiCeGBHQknGdBK/EgVkH2ahT20+wXdUStYNf2EaXAQ8UgoEV4FIgiWwr3OcvuICL3DR4VWyCJKDkkVsGWtpCkhRhtJNOl1ChhdaqI0cKesZB0na+MCmouhV0x0LIGqWSMx/77DV0hZDeOKBkkWsCWbSDlHvHZS9qTIV+YfRyZAk49j9SOkEoPKXX4utKi1S0hiSLTcZ2PUxNHJI5sxlPYQjFWUhke5aos1A6QSovLqxkf3l+xcNAn2G4QMWs8HU9YOhzxsHWIuzPgYGCyaJRpDeroiQjrIRV5/aLHyTd9ak2L5XCY9VyepYjGtj/I3fsf8D07I3zUR7VqDGcnDL6boPX6XJ+PaQxMtp/NaFzOSEd9GEkFefvmgldnJY4HFczeIbuaiicUQjV0Pn16y/T2NbXZc8zTYzKzKfvDAZNhn/++H9MeNXlz9xNXv//IoNckn9aQf//Q+fvDIaNRh9NmGT1x/+gB9go5Pt694sW0Q71T4vzmJb/8+SsXP085Ph/x180pv133eHfZp1YvoekZNjxu5N3Ux9kwR1RP49xaxx0K4U+lqdTz5CfXhGt9YlYV/ahOvJMhM9onO6xw0C9Qrqapdiy64xPK1QJ7yRiyEwzidHvn6a6QileJ4k9nKVpFas8v0I8vaR4dUyikCWfy+KIJNEVjnIwR0FRSrQO6k2+5bmeZNfL8D+eGp1AEB9zuAAAAAElFTkSuQmCC')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/4b290e93b9a61a5f6207b5cabf0352fb/e4706/1440p_Settings_System_WebUI_digital_Zoom.avif 230w", "/de/static/4b290e93b9a61a5f6207b5cabf0352fb/d1af7/1440p_Settings_System_WebUI_digital_Zoom.avif 460w", "/de/static/4b290e93b9a61a5f6207b5cabf0352fb/7f308/1440p_Settings_System_WebUI_digital_Zoom.avif 920w", "/de/static/4b290e93b9a61a5f6207b5cabf0352fb/face5/1440p_Settings_System_WebUI_digital_Zoom.avif 968w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/avif"
            }}></source><source parentName="picture" {...{
              "srcSet": ["/de/static/4b290e93b9a61a5f6207b5cabf0352fb/a0b58/1440p_Settings_System_WebUI_digital_Zoom.webp 230w", "/de/static/4b290e93b9a61a5f6207b5cabf0352fb/bc10c/1440p_Settings_System_WebUI_digital_Zoom.webp 460w", "/de/static/4b290e93b9a61a5f6207b5cabf0352fb/966d8/1440p_Settings_System_WebUI_digital_Zoom.webp 920w", "/de/static/4b290e93b9a61a5f6207b5cabf0352fb/61c9b/1440p_Settings_System_WebUI_digital_Zoom.webp 968w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/4b290e93b9a61a5f6207b5cabf0352fb/81c8e/1440p_Settings_System_WebUI_digital_Zoom.png 230w", "/de/static/4b290e93b9a61a5f6207b5cabf0352fb/08a84/1440p_Settings_System_WebUI_digital_Zoom.png 460w", "/de/static/4b290e93b9a61a5f6207b5cabf0352fb/c0255/1440p_Settings_System_WebUI_digital_Zoom.png 920w", "/de/static/4b290e93b9a61a5f6207b5cabf0352fb/e2310/1440p_Settings_System_WebUI_digital_Zoom.png 968w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/de/static/4b290e93b9a61a5f6207b5cabf0352fb/c0255/1440p_Settings_System_WebUI_digital_Zoom.png",
              "alt": "Web User Interface - 1440p Series - System WebUI",
              "title": "Web User Interface - 1440p Series - System WebUI",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      